<script>
    import {_} from '../lib/i18n';
    export let item;
    export let length = 100;

    function truncate( str, n, useWordBoundary ){
        if (str.length <= n) { return str; }
        const subString = str.slice(0, n-1); // the original check
        return (useWordBoundary
            ? subString.slice(0, subString.lastIndexOf(" "))
            : subString) + " ...";
    }

    let showFull = false;

    function showMore() {
        showFull = true;
    }
</script>

{#if showFull || (item.text && item.text.length < length)}
    <p class="feed-item-comment-content__text">
        {item.text}
    </p>
{:else}
    <p class="feed-item-comment-content__text">
        {truncate(item.text, length, true)}
    </p>
    <div class="feed-item-comment-content__show-more" on:click={showMore}>
        {$_('commentsResult.viewFullComment')}
    </div>
{/if}

<style>
.feed-item-comment-content__text {
    word-break: break-all;
}
</style>